import React from 'react';
import DateInput from '../../forms/DateInput';
import DateRangePicker from '../../forms/DateRangePicker';
import { DropDownList } from '@progress/kendo-react-dropdowns';

/**
* Date filter cell component
*/
export default class DateFilterCell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  handleChange = (name, value, e) => {
    this.setState({ value }, () =>
      this.props.onChange({
        value: value,
        operator: value ? this.props.operator ? this.props.operator : 'eq' : '',
        nativeEvent: e ? e.nativeEvent : new Event('change'),
        syntheticEvent: e ? e.syntheticEvent : new Event('change'),
      }));
  }

  handleOperatorChange = (e) => {
    const operator = e.target.value.operator;
    const isDate = this.state.value instanceof Date;
    const value = ((isDate && operator === 'between') || (!isDate && operator !== 'between')) ? null : this.state.value;

    this.setState({ value }, () =>
      this.props.onChange({
        value: value,
        operator: operator,
        nativeEvent: e.nativeEvent,
        syntheticEvent: e.syntheticEvent,
      }));
  }

  render() {
    const operator = (this.props.operators && this.props.operators.find(x => x.operator === this.props.operator)) || null;
    return (
      <div className={"k-filtercell"}>
        <span>
          {this.props.operator === 'between' ? (<DateRangePicker
            name={this.props.field}
            onChange={this.handleChange}
            value={this.state.value}
            format={'dd.MM.yy'}
            calendarSettings={{
              bottomView: 'month',
              topView: 'year',
              views: 3
            }}
          />) :
            (<DateInput
              type={this.props.type?.replace('input', '') || 'date'}
              onChange={this.handleChange}
              value={this.state.value}
              format={'dd.MM.yy'}
              name={this.props.field}
              todayHidden={true}
              validationHidden={true}
              placeholder={"Dátum"}
            />)}
          <div className={"k-filtercell-operator"}>
            <DropDownList
              className={'k-dropdown-operator'}
              data={this.props.operators}
              textField={'text'}
              value={operator}
              onChange={this.handleOperatorChange}
              iconClassName={'k-icon k-i-filter'}
              popupSettings={{ width: '' }}
            />
          </div>
        </span>
      </div>
    )
  }
}


